export const CACHE_TTL = {
  default: 60 * 1000,         // 1 minute default
  dashboard: 60 * 1000,       // 1 minute
  users: 60 * 1000,           // 1 minute
  clients: 120 * 1000,        // 2 minutes
  reports: 60 * 1000,         // 1 minute
  leads: 60 * 1000,           // 1 minute
  activity: 60 * 1000,        // 1 minute
  updates: 60 * 1000,         // 1 minute
  lookups: 300 * 1000,        // 5 minutes
} as const;

export type CacheModule = keyof typeof CACHE_TTL;

export function buildCacheKey(moduleName: string, ...parts: Array<string | number | boolean | null | undefined>): string {
  const cleanParts = parts
    .filter((p) => p !== null && p !== undefined && p !== '')
    .map((p) => String(p).trim());
  return cleanParts.length > 0 ? `${moduleName}:${cleanParts.join(':')}` : moduleName;
}
